module.exports = __webpack_public_path__ + "media/jigglypuff.4c5bd285.wav";